import React, { useContext, FC } from 'react';
import { FaAngleDoubleRight } from 'react-icons/fa';
import classNames from 'classnames';
import { RegisterModalContext } from 'app/contexts/RegisterModalContext';
import { ToogleLinkButton } from 'app/components/ToogleLinkButton/ToogleLinkButton';
import { BUTTON } from 'app/components/ToogleLinkButton/models.d';
import { UserFragmentProps } from './models';
import UserProfile from './UserProfile';
import { WSUserContext } from 'app/contexts/UserContext/UserContext';

import './UserFragment.scss';

const UserFragment: FC<UserFragmentProps> = ({ variant = 'navbar' }) => {
  const { openLoginModal } = useContext(RegisterModalContext);
  const user = useContext(WSUserContext);

  const userFragmentClasses = classNames('user-fragment', {
    [`user-fragment--${variant}`]: variant,
  });
  const userFragmentLoginClasses = classNames('user-fragment__login', {
    [`user-fragment__login--${variant}`]: variant,
  });

  const bntSignUpClasses = classNames('user-fragment__sign-up', {
    [`user-fragment__sign-up--${variant}`]: variant,
  });

  return (
    <div className={userFragmentClasses}>
      <div className={userFragmentLoginClasses}>
        {!user.isAuthenticated() ? (
          <ToogleLinkButton
            onClick={openLoginModal}
            variant={BUTTON.VARIANT.TEXT}
            size={variant === 'navbar' ? BUTTON.SIZE.SMALL : BUTTON.SIZE.MEDIUM}
            AppendChild={variant === 'navbar' ? <></> : <FaAngleDoubleRight />}
          >
            LOGIN
          </ToogleLinkButton>
        ) : (
          <UserProfile variant={variant} />
        )}
      </div>
      {!user.isAuthenticated() && (
        <ToogleLinkButton
          version={BUTTON.VERSION.INTERNAL_LINK}
          link="/sign-up"
          size={variant === 'navbar' ? BUTTON.SIZE.SMALL : BUTTON.SIZE.MEDIUM}
          round={
            variant === 'navbar' ? BUTTON.ROUND.STRONG : BUTTON.ROUND.STRONG
          }
          className={bntSignUpClasses}
        >
          Sign up free
        </ToogleLinkButton>
      )}
    </div>
  );
};

export default UserFragment;
